<template>
  <div>
    <el-drawer
      :destroy-on-close="true"
      :append-to-body="true"
      title="Ayarlar"
      :visible.sync="settings"
      :with-header="false"
    >
      <div class="row" style="padding: 50px">
        <div class="col-md-12">
          <label class="dark-inverted" for="">{{ $t("module.level") }}</label>
          <el-slider
            v-model="level"
            :step="1"
            :min="2"
            :max="4"
            show-stops
          ></el-slider>
        </div>

        <div class="col-md-12 mb-3">
          <label class="dark-inverted d-block" for="">{{
            $t("module.autolevel")
          }}</label>
          <el-switch
            style="margin-top: 8px"
            v-model="autoLevel"
            :active-text="$t('module.yes')"
            :active-value="1"
            :inactive-value="0"
            :inactive-text="$t('module.no')"
          >
          </el-switch>
        </div>
      </div>
    </el-drawer>
    <div id="goz_esnetme">
      <h1
        style="
          position: absolute;
          font-weight: bold;
          font-size: 27px;
          right: 230px;
          top: 20px;
        "
      >
        {{ timer }}
      </h1>

      <div
        style="
          width: 100%;
          height: 100%;
          background-color: #3e3e3e;
          z-index: 9999999999;
          padding: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
        "
        v-if="timer == 0"
      >
        <h1
          style="
            color: white;
            font-size: 36px;
            font-weight: bold;
            text-shadow: -1px 6px 10px rgb(0 0 0 / 60%);
            text-align: center;
            margin-top: 52px;
          "
        >
          <p
            v-html="
              $t('module.timeisend', {
                point: totalTrue,
              })
            "
          ></p>
          <a
            href="javascript:;"
            @click="begin"
            style="
              color: white;
              border-radius: 10px;
              border: 2px solid rgba(255, 255, 255, 0.5);
              font-size: 22px;
              padding: 10px 15px;
              margin-top: 30px;
              display: block;
            "
            >{{ $t("module.start_again") }}</a
          >
        </h1>
      </div>

      <a
        v-if="config == undefined || config == null"
        href="javascript:;"
        @click="settings = true"
        class="settings"
      >
        <i class="el-icon-setting"></i>
      </a>

      <div
        style="position: absolute; right: 30px; top: 120px; text-align: center"
      >
        <h1 style="font-size: 66px; font-weight: bold; color: #1c449c">
          {{ totalTrue }}
        </h1>
        <i class="fas fa-thumbs-up" style="font-size: 30px; color: #1c449c"></i>
      </div>
      <div
        style="position: absolute; right: 30px; top: 270px; text-align: center"
      >
        <h1 style="font-size: 66px; font-weight: bold; color: rgb(235 28 36)">
          {{ totalFalse }}
        </h1>
        <i
          class="fas fa-thumbs-down"
          style="font-size: 30px; color: rgb(235 28 36)"
        ></i>
      </div>

      <div class="swipe-cards">
        <div
          class="swipe-card"
          :key="item.id"
          :class="'swipe-card-' + index"
          :style="{
            bottom: 0,
          }"
          v-for="(item, index) in words"
        >
          <div
            :class="'ok-swipe-card-' + index"
            style="
              width: 100%;
              height: 100%;
              background-color: rgb(28 68 156);
              align-items: center;
              justify-content: center;
              position: absolute;
              left: 0px;
              top: 0px;
              z-index: 5;
              display: none;
              border-radius: 10px;
            "
          >
            <i
              class="fas fa-thumbs-up"
              style="color: white; font-size: 42px"
            ></i>
          </div>
          <span style="font-size: 30px">
            {{ item.word }}
          </span>
          <div class="options">
            <div
              class="option"
              @click="pick(index, optionIndex)"
              v-for="(option, optionIndex) in item.options"
            >
              <span style="width: 20px; height: 20px">
                <i class="far fa-square" v-if="option.picked == false"></i>
                <i
                  class="fas fa-check-square"
                  style="color: green"
                  v-if="option.picked && option.isTrue == true"
                ></i>
                <i
                  class="fas fa-times-circle"
                  style="color: red"
                  v-if="option.picked && option.isTrue == false"
                ></i>
              </span>
              <span style="font-size: 18px; margin-left: 10px">{{
                option.word
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import ucluler from "./esanlamlilar/besliler";
import dortluler from "./esanlamlilar/dortluler";
import besliler from "./esanlamlilar/ucluler";
import ucluler_ru from "./esanlamlilar/ucluler_ru";
import axios from "axios";
export default {
  name: "EsAnlamlilar",
  props: ["config"],
  data() {
    return {
      totalTrue: 0,
      totalFalse: 0,
      lodash: _,
      stack: {
        2: _.shuffle(
          ucluler.split(",").map((k) => {
            return [k.split("-")[0], k.split("-")[1], k.split("-")[2]];
          })
        ),
        3: _.shuffle(
          dortluler.split(",").map((k) => {
            return [
              k.split("-")[0],
              k.split("-")[1],
              k.split("-")[2],
              k.split("-")[3],
            ];
          })
        ),
        4: _.shuffle(
          besliler.split(",").map((k) => {
            return [
              k.split("-")[0],
              k.split("-")[1],
              k.split("-")[2],
              k.split("-")[3],
              k.split("-")[4],
            ];
          })
        ),
      },
      words: [],
      counter: 6,
      level: 2,
      levelMap: {
        2: 1,
        3: 1,
        4: 2,
      },
      pespeseDogru: 0,
      pespeseYanlis: 0,
      liveData: [],
      lock: false,
      autoLevel: 0,
      settings: false,
      totalClick: 0,
      reactions: [],
      lastPickTime: new Date().getTime(),
      timer: 60,
    };
  },
  mounted() {
  },
  beforeDestroy() {
  },
  created() {
    if (this.$i18n.locale == "ru") {
      this.stack = {
        2: _.shuffle(
          ucluler_ru.split(",").map((k) => {
            return [k.split("-")[0], k.split("-")[1], k.split("-")[2]];
          })
        ),
        4: _.shuffle(
          ucluler_ru.split(",").map((k) => {
            return [k.split("-")[0], k.split("-")[1], k.split("-")[2]];
          })
        ),
        5: _.shuffle(
          ucluler_ru.split(",").map((k) => {
            return [k.split("-")[0], k.split("-")[1], k.split("-")[2]];
          })
        ),
      };
    }

    if (this.config != null && this.config != undefined) {
      if (
        this.config.level != "" &&
        this.config.level != null &&
        this.config.level != undefined
      )
        this.level = this.config.level;
      this.autoLevel = this.config.auto_level;
    }
    for (let index = 0; index < 2; index++) {
      this.words.push({
        word: this.stack[this.level][0][0],
        id: index,
        options: _.shuffle(
          this.stack[this.level][0]
            .slice(1, this.stack[this.level][0].length)
            .map((item, index2) => {
              return {
                word: item,
                isTrue: index2 < this.levelMap[this.level] ? true : false,
                picked: false,
              };
            })
        ),
      });
      this.stack[this.level] = _.shuffle(this.stack[this.level]);
    }

    this.begin();


  },
  methods: {
    begin() {
      if (
        this.config != null &&
        this.config != undefined &&
        this.config.getTime() < 60
      ) {
        this.$root.$emit("done");
        return;
      }
      this.totalTrue = 0;
      this.totalFalse = 0;
      this.timer = 60;
      this.$root.$emit("pause", false);
      this.interval = setInterval(() => {
        this.timer -= 1;
        if (this.timer == 0) {
          //this.$root.$emit("pause", true);
          clearInterval(this.interval);

          axios.post("module/savePoints", {
            points: [
              {
                point: this.totalTrue,
                type: "dikkat",
              },
            ],
            module_id: this.$store.state.modules.find(
              (k) => k.slug == "es-anlamlilar"
            ).module_id,
          });

          axios.post("module/savePoints", {
            points: [
              {
                point:
                  this.reactions.reduce(
                    (counter, item) => (item += counter),
                    0
                  ) / this.reactions.length,
                type: "tepki",
              },
            ],
            module_id: this.$store.state.modules.find(
              (k) => k.slug == "es-anlamlilar"
            ).module_id,
          });
        }
      }, 1000);
    },
    pick(wordIndex, optionIndex) {
      this.totalClick += 1;
      if (this.words[wordIndex].options[optionIndex].picked || this.lock) {
        return;
      }
      if (
        this.words[wordIndex].options[optionIndex].isTrue == true &&
        !this.words[wordIndex].options.some(
          (k) => k.isTrue == true && k.picked == true
        )
      ) {
        this.reactions.push(new Date().getTime() - this.lastPickTime);
        this.lastPickTime = new Date().getTime();
      }
      this.words[wordIndex].options[optionIndex].picked = true;

      if (this.words[wordIndex].options[optionIndex].isTrue == true) {
        this.reactions.push(new Date().getTime() - this.lastPickTime);
        this.lastPickTime = new Date().getTime();
        this.pespeseDogru += 1;
        this.totalTrue += 1;

        this.pespeseYanlis = 0;
        if (this.$store.state.selectedTick2 != "sessiz")
          new Audio("/static/correct.mp3").play();
      } else {
        this.totalFalse += 1;
        if (this.$store.state.selectedTick2 != "sessiz")
          new Audio("/static/incorrect.mp3").play();
        this.pespeseDogru = 0;
        this.pespeseYanlis += 1;
        this.totalTrue = Math.max(this.totalTrue - 1, 0);

      }

      if (
        this.words[wordIndex].options.filter(
          (k) => k.picked == false && k.isTrue == true
        ).length == 0
      ) {
        this.lock = true;
        $(".ok-swipe-card-" + wordIndex).css("display", "flex");
        $(".ok-swipe-card-" + wordIndex).addClass(
          "animate__animated animate__zoomIn"
        );

        setTimeout(() => {
          $(".swipe-card-" + wordIndex).addClass(
            "animate__animated animate__zoomOutUp"
          );
          this.counter += 1;

          setTimeout(() => {
            var a = JSON.parse(JSON.stringify(this.words[wordIndex]));
            this.words.splice(wordIndex, 1);
            this.words = [
              {
                word: this.stack[this.level][0][0],
                id: this.counter,
                options: _.shuffle(
                  this.stack[this.level][0]
                    .slice(1, this.stack[this.level][0].length)
                    .map((item, index2) => {
                      return {
                        word: item,
                        isTrue:
                          index2 < this.levelMap[this.level] ? true : false,
                        picked: false,
                      };
                    })
                ),
              },
              ...this.words,
            ];
            this.stack[this.level] = _.shuffle(this.stack[this.level]);
            this.lock = false;
          }, 500);
        }, 500);
      }
    },
  },
  watch: {
    pespeseDogru: function () {
      if (this.autoLevel == 0) return;
      if (this.pespeseDogru > 4) {
        this.pespeseDogru = 0;
        this.level = Math.min(this.level + 1, 4);
      }

      if (this.pespeseYanlis > 2) {
        this.pespeseYanlis = 0;
        this.level = Math.max((this.level -= 1), 2);
      }
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  max-width: 700px;
  height: 500px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  background-color: #e0e0e0 !important;
}

.swipe-cards {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  position: relative;
  bottom: 30px;
  height: 500px;
  width: 500px;

  .swipe-card {
    height: 400px;
    width: 250px;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    background: white;
    border-radius: 10px;
    position: absolute;
    transition: 0.5s;
    border: 4px solid #f2f2f2;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-image: url("/static/img/2259.jpg");
    transform-origin: right;

    .options {
      width: 100%;
      padding: 10px;
      .option {
        width: 100%;
        cursor: pointer;
        padding: 10px 15px;
        background: whitesmoke;
        margin: 2px;
        border-radius: 10px;
        margin-bottom: 5px;
        transition: 0.3s;
        transform: scale(1);

        &:hover {
          transform: scale(1.1);
          background: white;
          color: #333 !important;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modules/EsAnlamlilar.vue